import gql from "graphql-tag";

export default gql`
    mutation ($input: ProductInput!){
        createProduct (input: $input) {
            id
            insert
            update
            name
        }
    }
`;
